var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:iconfont;src:url(" + escape(require("./iconfont.woff2?t=1627972636694")) + ") format(\"woff2\"),url(" + escape(require("./iconfont.woff?t=1627972636694")) + ") format(\"woff\"),url(" + escape(require("./iconfont.ttf?t=1627972636694")) + ") format(\"truetype\")}.iconfont{font-family:iconfont!important;font-size:16px;font-style:normal;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-ios:before{content:\"\\1234\"}.icon-arrow-down:before{content:\"\\E7AE\"}.icon-arrow-up:before{content:\"\\E7AF\"}.icon-add:before{content:\"\\E7B0\"}.icon-android:before{content:\"\\E7B1\"}.icon-notice:before{content:\"\\E7B2\"}.icon-search:before{content:\"\\E7B3\"}.icon-arrow-right:before{content:\"\\E7B4\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/assets/iconfont/iconfont.css
// module id = 20
// module chunks = 0